import React, { useMemo, useState } from "react";
import ToolCard from "./ToolCard";
import { CATEGORIES, TOOLS } from "./toolsConfig";
import { BLOG_ARTICLES } from "../data/blogData";

export default function ToolsGrid({
  initialCategory = "Tous",
  showPopular = true,
  limitPopular = 3,
}) {
  const [query, setQuery] = useState("");
  const [cat, setCat] = useState(initialCategory);

  const popularTools = useMemo(() => TOOLS.filter((t) => t.popular), []);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();

    return TOOLS.filter((t) => {
      const matchesCat = cat === "Tous" ? true : t.category === cat;
      if (!matchesCat) return false;

      if (!q) return true;

      const hay = [t.title, t.desc, t.category, ...(t.tags || [])]
        .join(" ")
        .toLowerCase();

      return hay.includes(q);
    });
  }, [query, cat]);

  return (
    <div>
      {/* Barre recherche + filtre */}
      <div style={{
        background: "white",
        padding: 16,
        borderRadius: 14,
        border: "1px solid #e2e8f0",
        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
      }}>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Rechercher un outil (ex : notaire, crédit, loyer...)"
            style={{
              flex: "1 1 320px",
              padding: 12,
              borderRadius: 12,
              border: "1px solid #e2e8f0",
              color: "#1e293b",
            }}
          />

          <select
            value={cat}
            onChange={(e) => setCat(e.target.value)}
            style={{
              padding: 12,
              borderRadius: 12,
              border: "1px solid #e2e8f0",
              minWidth: 180,
              color: "#1e293b",
              background: "white",
            }}
          >
            {CATEGORIES.map((c) => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>
        </div>

        {/* Quick chips */}
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 12 }}>
          {CATEGORIES.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              style={{
                padding: "8px 12px",
                borderRadius: 999,
                border: "1px solid #e2e8f0",
                background: c === cat ? "#1e40af" : "white",
                color: c === cat ? "white" : "#475569",
                cursor: "pointer",
                fontWeight: c === cat ? 600 : 500,
                transition: "all 0.15s ease",
              }}
            >
              {c}
            </button>
          ))}
        </div>
      </div>

      {/* Populaires */}
      {showPopular && (
        <section style={{ marginTop: 18 }}>
          <h2 style={{ marginBottom: 10 }}>Les plus utilisés</h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
              gap: 12,
            }}
          >
            {popularTools.slice(0, limitPopular).map((t) => (
              <ToolCard key={t.id} tool={t} />
            ))}
          </div>
        </section>
      )}

      {/* Section Blog */}
      <section style={{ marginTop: 32 }}>
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16
        }}>
          <h2 style={{ margin: 0 }}>Conseils immobiliers</h2>
          <a
            href="/blog"
            style={{
              color: "#1e40af",
              textDecoration: "none",
              fontWeight: 500,
              fontSize: 14
            }}
          >
            Voir tous les articles →
          </a>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: 16,
          }}
        >
          {BLOG_ARTICLES.slice(0, 3).map((article) => (
            <a
              key={article.id}
              href={`/blog/${article.slug}`}
              style={{
                display: "block",
                background: "white",
                borderRadius: 12,
                border: "1px solid #e2e8f0",
                overflow: "hidden",
                textDecoration: "none",
                color: "inherit",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
              }}
              className="card-hover"
            >
              <div style={{
                height: 140,
                background: `linear-gradient(135deg, ${article.gradient})`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 48,
              }}>
                {article.emoji}
              </div>
              <div style={{ padding: 16 }}>
                <div style={{
                  fontSize: 12,
                  color: "#1e40af",
                  fontWeight: 600,
                  marginBottom: 6,
                  textTransform: "uppercase",
                  letterSpacing: "0.05em"
                }}>
                  {article.category}
                </div>
                <h3 style={{
                  margin: "0 0 8px 0",
                  fontSize: 16,
                  fontWeight: 600,
                  color: "#1e293b",
                  lineHeight: 1.4
                }}>
                  {article.title}
                </h3>
                <p style={{
                  margin: 0,
                  fontSize: 14,
                  color: "#64748b",
                  lineHeight: 1.5
                }}>
                  {article.excerpt}
                </p>
              </div>
            </a>
          ))}
        </div>
      </section>

      {/* Liste filtrée */}
      <section style={{ marginTop: 18 }}>
        <h2 style={{ marginBottom: 10 }}>
          Tous les outils {cat !== "Tous" ? `• ${cat}` : ""}
        </h2>

        {filtered.length === 0 ? (
          <p style={{ opacity: 0.75 }}>
            Aucun outil trouvé. Essaie un autre mot-clé.
          </p>
        ) : (
          <div
            className="tools-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
              gap: 12,
            }}
          >
            {filtered.map((t) => (
              <ToolCard key={t.id} tool={t} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
